// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1023.98px) {
  :host-context(.im-mobile-overview) {
    display: block;
    margin-top: 0.45rem;
  }
  :host-context(.im-mobile-overview) .imos-mobile-card {
    margin: 0 0 0.45rem;
    padding: 0.45rem;
    border-radius: 0.85rem;
  }
  :host-context(.im-mobile-overview) .imos-mobile-grid {
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));
    gap: 0.4rem;
  }
  :host-context(.im-mobile-overview) .imos-mobile-grid > div {
    min-width: 0;
    padding: 0.55rem !important;
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 0.65rem;
    background: rgba(148, 163, 184, 0.1);
  }
  :host-context(.im-mobile-overview) .imos-mobile-grid > :last-child:nth-child(odd) {
    grid-column: 1/-1;
  }
  :host-context(.im-mobile-overview) .imos-mobile-grid ion-card-subtitle {
    margin-bottom: 0.2rem;
    font-size: 0.72rem;
    letter-spacing: 0.02em;
  }
  :host-context(.im-mobile-overview) .imos-mobile-grid ion-card-title,
  :host-context(.im-mobile-overview) .imos-mobile-grid .text-2xl,
  :host-context(.im-mobile-overview) .imos-mobile-grid .text-xl {
    min-width: 0;
    font-size: 1.05rem;
    line-height: 1.2;
    word-break: break-word;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ordine-sessioni/ordine-sessioni.component.scss"],"names":[],"mappings":"AAAA;EACE;IACE,cAAA;IACA,mBAAA;EACF;EAEA;IACE,mBAAA;IACA,gBAAA;IACA,sBAAA;EAAF;EAGA;IACE,wBAAA;IACA,4DAAA;IACA,WAAA;EADF;EAIA;IACE,YAAA;IACA,2BAAA;IACA,2CAAA;IACA,sBAAA;IACA,oCAAA;EAFF;EAKA;IACE,iBAAA;EAHF;EAMA;IACE,qBAAA;IACA,kBAAA;IACA,sBAAA;EAJF;EAOA;;;IAGE,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,sBAAA;EALF;AACF","sourcesContent":["@media (max-width: 1023.98px) {\n  :host-context(.im-mobile-overview) {\n    display: block;\n    margin-top: 0.45rem;\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-card {\n    margin: 0 0 0.45rem;\n    padding: 0.45rem;\n    border-radius: 0.85rem;\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-grid {\n    display: grid !important;\n    grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));\n    gap: 0.4rem;\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-grid > div {\n    min-width: 0;\n    padding: 0.55rem !important;\n    border: 1px solid rgba(148, 163, 184, 0.35);\n    border-radius: 0.65rem;\n    background: rgba(148, 163, 184, 0.1);\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-grid > :last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-grid ion-card-subtitle {\n    margin-bottom: 0.2rem;\n    font-size: 0.72rem;\n    letter-spacing: 0.02em;\n  }\n\n  :host-context(.im-mobile-overview) .imos-mobile-grid ion-card-title,\n  :host-context(.im-mobile-overview) .imos-mobile-grid .text-2xl,\n  :host-context(.im-mobile-overview) .imos-mobile-grid .text-xl {\n    min-width: 0;\n    font-size: 1.05rem;\n    line-height: 1.2;\n    word-break: break-word;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
